var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtRefreshCw01Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6589 6.34511C16.21 4.89514 14.2105 4 12.0001 4C7.58183 4 4.0001 7.58172 4.0001 12C4.0001 16.4183 7.58183 20 12.0001 20C15.6458 20 18.7244 17.5605 19.6875 14.2227C19.8407 13.6921 20.395 13.3861 20.9256 13.5392C21.4562 13.6923 21.7623 14.2466 21.6091 14.7773C20.4056 18.9481 16.5606 22 12.0001 22C6.47726 22 2.0001 17.5228 2.0001 12C2.0001 6.47715 6.47726 2 12.0001 2C14.7625 2 17.2649 3.12139 19.0736 4.93138C19.7097 5.56789 20.3942 6.35772 21 7.09434V4C21 3.44772 21.4477 3 22 3C22.5523 3 23 3.44772 23 4V10C23 10.5523 22.5523 11 22 11H16C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9H19.9693C19.2852 8.14144 18.4232 7.10987 17.6589 6.34511Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtRefreshCw01Filled);
export default __webpack_public_path__ + "static/media/at_refresh-cw-01-filled.fec5fcd151e030a0a40f9136e323a51c.svg";
export { ForwardRef as ReactComponent };